import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {ReactComponent as SvgDotPatternIcon} from "../../images/dot-pattern.svg"

import { useForm } from "react-hook-form";
import { useSnackbar } from "react-simple-snackbar";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`

export default ({toggleModal, loggato, setLoggato}) => {

  const { register, handleSubmit, watch, errors } = useForm();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const onSubmit = data => {
    console.log(data);

    if(data.nome!=='' && data.email !=='' && data.citta!=='' && data.password!=='' && data.password_ripetuta!==''){

      if(data.password === data.password_ripetuta){

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: JSON.stringify(data)
        };

        fetch('https://recode.digital/corona-anti-virus/index.php/api/crea_utente/', requestOptions)
          .then(response => response.text())
          .then(dati => {
              console.log(dati);
              if(dati.trim()==='ok'){

                setLoggato(true);

                let md5 = require('md5');

                localStorage.setItem('email_1000', data.email);
                localStorage.setItem('password_1000', md5(data.password));

                toggleModal();

                openSnackbar('Iscrizione avvenuta con successo!');
              }
              else if(dati.trim()==='errore-creazione-utente'){
                  //avviaModale('Attenzione','Si è verificato un errore durante l\'invio del tuo ordine. Riprova di nuovo.');
                  openSnackbar('Si è verificato un errore durante la creazione dell\'utente. Riprovare più tardi');
              }
              else if('errore-email-presente'){
                openSnackbar('È già presente un utente registrato con questa e-mail. Prova con un altro indirizzo e-mail');
              }
          });

      }
      else{
        openSnackbar("I campi password non coincidono!")
      }

      //localStorage.setItem('infoOrdine', JSON.stringify(data));

      
      

    }else{
        alert("Completa tutti i campi richiesti prima di procedere.")
    }
  }

  return (
    <Container id="form_iscrizione">
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl" >
            <div style={{textAlign:"right"}} onClick={toggleModal}>
              <p><b>X Chiudi</b></p>
            </div>
            {/* <h2>Iscriviti ora 🙏🏻</h2> */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <TwoColumn>
                <Column>
                  <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <Label htmlFor="nome">Nome di Battesimo</Label>
                    <Input ref={register} id="nome" type="text" name="nome" placeholder="" />
                  </InputContainer>
                  <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <Label htmlFor="citta">Città</Label>
                    <Input ref={register} id="citta" type="text" name="citta" placeholder="" />
                  </InputContainer>
                  <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <Label htmlFor="email">Indrizzo E-mail</Label>
                    <Input ref={register} id="email" type="email" name="email" placeholder="" />
                  </InputContainer>
                </Column>
                <Column>
                <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <Label htmlFor="password">Password</Label>
                    <Input ref={register} id="password" type="password" name="password" placeholder="" />
                  </InputContainer>
                  <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <Label htmlFor="password_ripetuta">Conferma Password</Label>
                    <Input ref={register} id="password_ripetuta" type="password" name="password_ripetuta" placeholder="" />
                  </InputContainer>
                  <InputContainer style={{paddingTop:"0.9rem", paddingBottom: "0.3rem"}}>
                    <input type="checkbox" name="gdpr" value="gdpr" required /><br></br>
                    <label for="gdpr" style={{size:"7px"}}>Ho letto l'inf. privacy e acconsento al trattamento dei dati (norm. europea protezione dei dati personali n. 679/2016, GDPR) </label>
                  </InputContainer>
                </Column>
              </TwoColumn>

              <SubmitButton type="submit" value="Submit">Effettua l'iscrizione</SubmitButton>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
